import template from 'url-template';
import _ from 'lodash';

import {
    FETCH_DASHBOARD_CONVERSIONS,
    SET_SELECTED_CONVERSION
} from '../actions/actionTypes';

import awsHeader from '../helpers/awsAuth';
import { k2aBaseCacheApi } from '../apis/key2act';

import { handleNetworkError, enqueueSnackbar } from './applicationMessageActions';

const SpecificConversionUrl = template.parse('/conversions/{conversionId}');
const ConversionsUrl = template.parse('/companies/{companyId}/conversions{?searchFilter,limit}');

const DEFAULT_PAGE_LIMIT = 100;

export const createConversion = (companyId, body, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await k2aBaseCacheApi.post(
            ConversionsUrl.expand({
                companyId,
                ...options
            }),
            body,
            header
        );

        await dispatch(fetchConversions(companyId));
        dispatch(enqueueSnackbar('Conversion created successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const fetchConversions = (companyId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const response = await k2aBaseCacheApi.get(
            ConversionsUrl.expand({
                companyId,
                ...options
            }),
            header
        );
        const payload = _.get(response, 'data.data', []).sort((a, b) => _sorter(a, b));

        let k2aConversions = [];
        let customConversions = [];

        payload.forEach(item => {
            if (item.conversionType.toLowerCase() === 'key2act') {
                k2aConversions.push(item);
            } else {
                customConversions.push(item);
            }
        });

        dispatch({
            type:    FETCH_DASHBOARD_CONVERSIONS,
            payload: {
                k2a:    [...k2aConversions],
                custom: [...customConversions]
            }
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const deleteConversion = (conversionId, companyId) => async dispatch => {
    const header = await awsHeader();

    try {
        await k2aBaseCacheApi.delete(
            SpecificConversionUrl.expand({ conversionId }),
            {
                headers: header.headers
            }
        );

        dispatch(enqueueSnackbar('Conversion deleted successfully.', 'success'));
        await dispatch(fetchConversions(companyId));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
};

export const setSelectedConversion = conversion => async (dispatch, getState) => {
    dispatch({
        type:    SET_SELECTED_CONVERSION,
        payload: conversion
    });
};

export const updateConversion = (conversionId, companyId, body, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await k2aBaseCacheApi.put(
            SpecificConversionUrl.expand({
                conversionId,
                ...options
            }),
            body,
            header
        );

        await dispatch(fetchConversions(companyId));
        dispatch(enqueueSnackbar('Conversion updated successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

const _sorter = (a, b) => {
    let roleA = a.name.toUpperCase();
    let roleB = b.name.toUpperCase();

    if (roleA < roleB) {
        return -1;
    }
    if (roleA > roleB) {
        return 1;
    }

    return 0;
};
